import { BlogPostContent } from '@/types/blog';
import { introSection } from './sections/intro';
import { mentaleFitnessSection } from './sections/mentale-fitness';
import { umgebungSection } from './sections/umgebung';
import { fuehrungsstilSection } from './sections/fuehrungsstil';
import { ethikSection } from './sections/ethik';
import { coachingUmfeldSection } from './sections/coaching-umfeld';
import { naechsterSchrittSection } from './sections/naechster-schritt';

export const content: BlogPostContent = {
  sections: [
    introSection,
    mentaleFitnessSection,
    umgebungSection,
    fuehrungsstilSection,
    ethikSection,
    coachingUmfeldSection,
    naechsterSchrittSection
  ]
};
